/**
 * フッターのタイプを判定するcomposable
 */
export const useFooterType = () => {
  /**
   * グレー背景のフッターを表示するページのパスリスト
   */
  const grayFooterPages = ['/', '/result'] as const;

  /**
   * 現在のページがグレー背景のフッターを表示するページかどうかを判定する
   *
   * @param path - 判定対象のパス（クエリパラメータを含む場合がある）
   * @returns グレー背景のフッターを表示する場合はtrue
   */
  const isGrayFooterPage = (path: string): boolean => {
    const pathWithoutQuery = path.split('?')[0];
    return grayFooterPages.some((grayPath) => {
      // 完全一致または/shareで始まるパスの場合
      return (
        pathWithoutQuery === grayPath || pathWithoutQuery.startsWith('/share')
      );
    });
  };

  return {
    isGrayFooterPage,
  };
};
